import React, { useState } from "react";
import PropTypes from "prop-types";
import { VisualEditorContextProvider } from "./context";

export const VisualEditorProvider = ({ children }) => {
  const [isEditorFocused, setIsEditorFocused] = useState(false);

  return (
    <VisualEditorContextProvider
      value={{
        isEditorFocused,
        setIsEditorFocused,
      }}
    >
      {children}
    </VisualEditorContextProvider>
  );
};

VisualEditorProvider.propTypes = {
  children: PropTypes.any,
};
